// Status type definitions - designed for future extensibility
export const DEFAULT_STATUSES = {
  OPERATIONAL: 'operational',
  DEGRADED: 'degraded', 
  OUTAGE: 'outage'
};

// Status configuration with display properties
export const STATUS_CONFIG = {
  [DEFAULT_STATUSES.OPERATIONAL]: {
    name: 'Operational',
    color: '#28a745', // Green
    icon: '🟢'
  },
  [DEFAULT_STATUSES.DEGRADED]: {
    name: 'Degraded', 
    color: '#ffc107', // Yellow
    icon: '🟡'
  },
  [DEFAULT_STATUSES.OUTAGE]: {
    name: 'Outage',
    color: '#dc3545', // Red  
    icon: '🔴'
  }
};

// Get all available statuses (for dropdowns, etc.)
export function getAvailableStatuses() {
  return Object.keys(STATUS_CONFIG);
}

// Get status display name
export function getStatusDisplayName(statusKey) {
  return STATUS_CONFIG[statusKey]?.name || statusKey;
}

// Get status color
export function getStatusColor(statusKey) {
  return STATUS_CONFIG[statusKey]?.color || '#6c757d';
}

// Get status icon
export function getStatusIcon(statusKey) {
  return STATUS_CONFIG[statusKey]?.icon || '⚪';
}

// Sort options by status priority (Operational, Degraded, Outage)
export function sortOptionsByStatus(options) {
  const statusOrder = [DEFAULT_STATUSES.OPERATIONAL, DEFAULT_STATUSES.DEGRADED, DEFAULT_STATUSES.OUTAGE];
  
  return [...options].sort((a, b) => {
    const aIndex = statusOrder.indexOf(a.status);
    const bIndex = statusOrder.indexOf(b.status);
    
    // If both have valid statuses, sort by status order
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }
    
    // If only one has a valid status, prioritize it
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
    
    // If neither has a valid status, maintain original order
    return 0;
  });
}

// Future: Custom status management functions
// These would be implemented when custom statuses are added:

// export function addCustomStatus(statusKey, config) {
//   STATUS_CONFIG[statusKey] = config;
// }

// export function removeCustomStatus(statusKey) {
//   delete STATUS_CONFIG[statusKey];
// }

// export function updateCustomStatus(statusKey, config) {
//   STATUS_CONFIG[statusKey] = { ...STATUS_CONFIG[statusKey], ...config };
// }
